import { captureRemixErrorBoundaryError } from "@sentry/remix";
import { json, LoaderFunctionArgs, type LinksFunction } from "@remix-run/node";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useRouteError,
} from "@remix-run/react";

import tailwind from "./tailwind.css?url";
import css from "./_index.css?url";
import { ModalContextProvider } from "@bohiio/ui-components";
import { RegisterAuthenticationModals } from "./modals/modal-register";
import { EnvValues } from "./templates/base";
import { authenticate } from "./utils/authenticate";
import { getSession } from "./utils/session.server";
import { getFullUserInfo } from "./utils/profile/profile.server";
import { withError } from "./utils/http";
import { UserInfo } from "./utils/profile/types";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: tailwind },
  { rel: "stylesheet", href: css },
];

export async function loader({ request }: LoaderFunctionArgs) {
  const envJSON = {
    ENV: {
      CDN_URL: process.env.BOHIIO_CDN_URL,
      SERVICE_PHONE_NUMBER: process.env.SERVICE_PHONE_NUMBER,
      BOHIIO_MARKETPLACE_URL: process.env.BOHIIO_MARKETPLACE_URL,
      GA_TRACKING_ID: process.env.GA_TRACKING_ID,
      SENTRY_DSN: process.env.SENTRY_DSN,
      ENVIRONMENT: process.env.ENVIRONMENT
    },
  } as { ENV: any };

  return json(envJSON);
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

export default function App() {
  const data = useLoaderData<typeof loader>();
  return (
    <html lang="es">
      <head>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />
        <Meta />
        <Links />
      </head>
      <body>
        {/* <ModalContextProvider> */}
        {/* <RegisterAuthenticationModals env={data.ENV}> */}
        <Outlet />
        {/* </RegisterAuthenticationModals> */}
        {/* </ModalContextProvider> */}
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(data.ENV)}`,
          }}
        />
        {!data.ENV.GA_TRACKING_ID ? null : (
          <>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${data.ENV.GA_TRACKING_ID}`}
            />
            <script
              async
              id="gtag-init"
              dangerouslySetInnerHTML={{
                __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }
                gtag("js", new Date());
                gtag('config', '${data.ENV.GA_TRACKING_ID}', {
                  page_path: window.location.pathname,
                });
                `,
              }}
            />
          </>
        )}
        <Scripts />
      </body>
    </html>
  );
}